import Vue from 'vue';
import Vuex from 'vuex';
import { AppRootStore } from './AppRootStore';

Vue.use(Vuex);

const store = new Vuex.Store(new AppRootStore());

export default store;
